import React, { useEffect, useRef, useState } from 'react'
import { Alert, Button, Card, CardBody, Col, Row } from 'reactstrap'
import { Textbox, Radiobox } from "react-inputs-validation";
import { urlConsultarPlaca, urlObtenerDataPoliza, urlObtenerDatosVehiculo } from '../../constants/urls';
import SelectC from '../Generales/Select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import ComponentButtonS3 from './ComponentButtonS3';
import ComponentLista from './ComponentLista';
import ComponentListaInputValoresEstablecidos from './ComponentListaInputValoresEstablecidos';
import { esNumero } from '../../utils/validaciones';
import SelectPreguntas from '../Generales/SelectPreguntas';




const ComponentPreguntasParametrico = ({
    setLoading,
    onRegresar,
    guardarInformacion,
    categorias,
    setCategorias,
    categoriaSeleccionada,
    setCategoriaSeleccionada,
    indiceSeleccionado,
    setIndiceSeleccionado,
    obtenerPreguntas,
    datosCarrito,
    aplicaControlDuplicidad,
    placaDuplicada,
    setPlacaDuplicada,
    setMensajeDuplicado,
    mensajeDuplicado
}) => {







    const [validations, setValidations] = useState({})
    const [buscarElemento] = useState(false)
    const [valorAsegurado, setValorAsegurado] = useState(0)
    const mensajeValidacion = useRef(null);

    useEffect(() => {

        if (datosCarrito && datosCarrito.carValorAsegurado) {
            setValorAsegurado(datosCarrito.carValorAsegurado)

        }

    }, [datosCarrito])







    const obtenerSiguienteElemento = (paso) => {

        const indiceActual = categorias.indexOf(categoriaSeleccionada)



        const primerIndice = 0;
        const ultimoIndice = categorias.length - 1

        const previous = indiceActual == primerIndice ? categorias[ultimoIndice] : categorias[indiceActual - 1];
        const next = indiceActual == ultimoIndice ? categorias[primerIndice] : categorias[indiceActual + 1];

        const previousIndex = categorias.indexOf(previous);
        const nextIndex = categorias.indexOf(next);






        if (paso == 'siguiente') {
            setCategoriaSeleccionada(next)
            setIndiceSeleccionado(nextIndex)
        } else {
            setCategoriaSeleccionada(previous)
            setIndiceSeleccionado(previousIndex)
        }

        window.scrollTo(0, 0);

    }

    const obtenerDatosVehiculo = async (placa) => {

        setLoading(true)

        const urlAux = `${urlObtenerDatosVehiculo}${placa.toUpperCase()}`;

        try {
            const response = await fetch(urlAux)
            const json = await response.json()


            if (json.transaccion) {


                let preguntas = [...categoriaSeleccionada.preguntas]


                const preguntaChasis = preguntas.find(pregunta => pregunta.cuesPregunta == 'Chasis')
                const indexChasis = preguntas.findIndex(pregunta => pregunta == preguntaChasis)
                const preguntaMotor = preguntas.find(pregunta => pregunta.cuesPregunta == 'Motor')
                const indexMotor = preguntas.findIndex(pregunta => pregunta == preguntaMotor)

                const preguntaAnio = preguntas.find(pregunta => pregunta.cuesPregunta == 'Año')
                const indexAnio = preguntas.findIndex(pregunta => pregunta == preguntaAnio)





                const preguntaMarca = preguntas.find(pregunta => pregunta.cuesPregunta == 'Marca')
                const indexMarca = preguntas.findIndex(pregunta => pregunta == preguntaMarca)

                if (preguntaMarca && indexMarca) {
                    cambiarValorSelect(json.marca, preguntaMarca, indexMarca)
                }

                if (preguntaAnio && indexAnio) {
                    //    cambiarValorSelect(json.anio, preguntaAnio, indexAnio)
                }

                const preguntaModelo = preguntas.find(pregunta => pregunta.cuesPregunta == 'Modelo')
                const indexModelo = preguntas.findIndex(pregunta => pregunta == preguntaModelo)

                if (preguntaModelo && indexModelo) {
                    cambiarValorSelect(json.modelo, preguntaModelo, indexModelo)
                }





                if (preguntaChasis && indexChasis) {
                    cambiarValor(json.chasis, preguntaChasis, indexChasis)
                }

                if (preguntaMotor && indexMotor) {
                    cambiarValor(json.motor, preguntaMotor, indexMotor)
                }

                validationCallbackAuto(false)
            }
            setLoading(false)
            window.scrollTo(0, 0);

        } catch (error) {
            setLoading(false)
        }

    }

    const validationCallbackAuto = (valor) => {

        let objeto = { ...validations }
        objeto['Chasis'] = valor;
        objeto['Motor'] = valor;
        objeto['Marca'] = valor;
        objeto['Placa'] = valor;
        setValidations(objeto)
    }

    const validationCallbackSiNo = (key, valor) => {

        let objeto = { ...validations }

        objeto[key] = valor


        setTimeout(() => {
            setValidations(objeto)
        }, 300);


    }





    useEffect(() => {

        if (categoriaSeleccionada) {



            let validationsAux = {}



            categoriaSeleccionada.preguntas.forEach(pregunta => {

                validarPregunta(pregunta)
                validationsAux =
                {
                    ...validationsAux,
                    [pregunta.cuesPregunta]: validarPregunta(pregunta)
                }
            });


            setValidations(validationsAux)
        }


    }, [categoriaSeleccionada])


    /**
 * Función que determina si una pregunta está deshabilitada o no.
 * @param {Object} pregunta - La pregunta a evaluar.
 * @param {Object} categoriaSeleccionada - La categoria seleccionada.
 * @return {Boolean} - Verdadero si la pregunta está deshabilitada, falso en caso contrario.
 */
    function isDisabled(pregunta, categoriaSeleccionada) {
        // si no tiene un padre o el valor del padre es vacío, la pregunta está habilitada
        if (pregunta.cuesPadre == null || pregunta.cuesPadre == '') {
            return false;
        }
        // busca la pregunta padre en la categoria seleccionada
        const padre = categoriaSeleccionada.preguntas.find(v => v.cuesPregunta == pregunta.cuesPadre);
        // si no encuentra la pregunta padre, la pregunta está habilitada
        if (!padre) {
            return false;
        }
        // si el valor de la pregunta padre es diferente al valor de dependencia de la pregunta actual, la pregunta está deshabilitada
        return padre.value != pregunta.cuesDepende;
    }

    async function validarDuplicidad(placa, motor, chasis) {
        const url = `${urlObtenerDataPoliza}&placa=${placa}&motor=${motor}&chasis=${chasis}`
        const response = await fetch(url)
        const json = await response.json()
        return json

    }


    /**
     * 
     * @param {*} pregunta 
     * @returns 
     */
    const validarPregunta = (pregunta) => {

        switch (pregunta.cuesTipo) {
            case 'SINO':
                return (!pregunta.value || pregunta.value.trim() == '')

            case 'archivo':
                return (!pregunta.value || pregunta.value.trim() == '')

            case 'texto':
                return (!pregunta.value || pregunta.value.trim() == '')

            case 'numerico':

                return isDisabled(pregunta, categoriaSeleccionada) ? false : !esNumero(pregunta.value)

            case 'numericoMaximoMinimo':
                return isDisabled(pregunta, categoriaSeleccionada) ? false : !esNumero(pregunta.value)

            case 'textolongitud':

                let aux = true

                if (pregunta.value) {

                    if (pregunta.value.length <= parseFloat(pregunta.cuesMaximo) && pregunta.value.length >= parseFloat(pregunta.cuesMinimo)) {
                        aux = false
                    }
                }
                return aux

            case 'web':

            let tieneValor =  pregunta.value && typeof  pregunta.value === 'object' ? true : false
            let esPreguntaRequeridaAux =  esPreguntaRequerida(pregunta, categoriaSeleccionada)
            let validador = !esPreguntaRequeridaAux ? false : !tieneValor && esPreguntaRequeridaAux ? true : false

                return validador ? true : pregunta.cuesMultiple ? false : !obtenerPreguntas ? false : true

            case 'fecha':
                return false

            case 'select':
                return !pregunta.value || pregunta.value.esBloqueante == 'SI'

            default:
                return false;

        }



    }








    const validationCallback2 = (valor, pregunta) => {

        let objeto = { ...validations }
        objeto[pregunta] = valor;




        setValidations(objeto)

    }

    const esPreguntaRequerida = (pregunta, categoriaSeleccionada) => {
        // estas dos siempre requeridas
        if (pregunta.cuesPregunta === 'Industria' || pregunta.cuesPregunta === 'Giro del negocio') {
            return true;
        }

        // si no tiene padre → no requerida
        if (!pregunta.cuesPadre) {
            return false;
        }

        // buscar padre
        const padre = categoriaSeleccionada.preguntas.find(
            v => v.cuesPregunta === pregunta.cuesPadre
        );

        // si no existe el padre → no requerida
        if (!padre) {
            return false;
        }

        // requerida si el valor del padre coincide con el cuesDepende
        return padre.value === pregunta.cuesDepende;
    };



    const cambiarValor = (valor, pregunta, indexPreguntas) => {




        let categoriasAux = [...categorias]
        let preguntasAux = [...categoriaSeleccionada.preguntas]

        preguntasAux[indexPreguntas] = {
            ...pregunta, value: valor
        }

        categoriasAux[indiceSeleccionado].preguntas = preguntasAux
        setCategoriaSeleccionada(categoriasAux[indiceSeleccionado])

        setCategorias(categoriasAux)

    }

    const cambiarValorSelect = (valor, pregunta, indexPreguntas) => {

        let categoriasAux = [...categorias]
        let preguntasAux = [...categoriaSeleccionada.preguntas]

        preguntasAux[indexPreguntas] = {
            ...pregunta, valueSelect: valor
        }

        categoriasAux[indiceSeleccionado].preguntas = preguntasAux
        setCategoriaSeleccionada(categoriasAux[indiceSeleccionado])

        setCategorias(categoriasAux)

    }

    const tieneErrores = () => {

        let categoriasAux = [...categorias]

        categoriasAux[indiceSeleccionado].validate = !categoriasAux[indiceSeleccionado].validate
        setCategorias(categoriasAux)

        let tieneErroresAux = false



        for (const key in validations) {

            const element = validations[key];


            if (element) {
                tieneErroresAux = true
            }
        }
        return tieneErroresAux





    }

    return (
        <Row>
            <Col
                lg={10}
                md={12}
                sm={12}
                xs={12}
                className="div-align-center"
            >
                <Card>
                    <CardBody>
                        <h4 style={{ fontWeight: 'bold' }}>{`Preguntas (${indiceSeleccionado + 1}/${categorias.length})`}</h4>

                        {/* {JSON.stringify(Object.entries(validations).filter(val => val[1] == true))} */}


                        {
                            categoriaSeleccionada &&
                            <div style={{ marginLeft: 20 }}>
                                <br></br>
                                <h5 style={{ fontWeight: 'bold' }}>{categoriaSeleccionada.catpregDescripcion}</h5>
                                <br></br>


                                {categoriaSeleccionada.preguntas.sort(function (a, b) {
                                    if (a.cuesOrden < b.cuesOrden) return -1;
                                    if (b.cuesOrden < a.cuesOrden) return 1;
                                    return 0;
                                }).map((pregunta, indexPreguntas) => {




                                    return (
                                        <div key={indexPreguntas} style={{ marginLeft: 20 }}>
                                            <Row>
                                                <Col md={6}>{pregunta.cuesPregunta}</Col>
                                                <Col md={6}>




                                                    {pregunta.cuesTipo == 'SINO' &&
                                                        <Radiobox
                                                            id={indexPreguntas + "a" + indiceSeleccionado}
                                                            //Optional.[Bool].Default: false.
                                                            value={pregunta.value} //Optional.[String].Default: "".
                                                            validate={categoriaSeleccionada.validate} //Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at once, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                                                            optionList={pregunta.valuesRadio}
                                                            classNameInput="" //Optional.[String].Default: "".
                                                            classNameWrapper="" //Optional.[String].Default: "".
                                                            classNameContainer="" //Optional.[String].Default: "".
                                                            classNameOptionListItem="" //Optional.[String].Default: "".
                                                            customStyleInput={{}} //Optional.[Object].Default: {}.
                                                            customStyleWrapper={{}} //Optional.[Object].Default: {}.
                                                            customStyleContainer={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-end'
                                                            }} //Optional.[Object].Default: {}.
                                                            customStyleOptionListItem={{ marginRight: '20px' }} //Optional.[Object].Default: {}.
                                                            onChange={(valor) => {

                                                                const valoresEncontrados = categoriaSeleccionada.preguntas.filter(v => v.cuesPadre == pregunta.cuesPregunta)

                                                                valoresEncontrados.reverse().forEach(preguntaEncontrada => {

                                                                    const indice = categoriaSeleccionada.preguntas.indexOf(preguntaEncontrada)
                                                                    if (valor == 'si') {
                                                                        validationCallbackSiNo(preguntaEncontrada.cuesPregunta, true)
                                                                    } else {
                                                                        validationCallbackSiNo(preguntaEncontrada.cuesPregunta, false)
                                                                    }
                                                                    cambiarValor("", preguntaEncontrada, indice)
                                                                });




                                                                cambiarValor(valor, pregunta, indexPreguntas)


                                                            }} //Required.[Func].Default: () => {}. Will return the value.
                                                            onBlur={(e) => {

                                                            }}
                                                            validationOption={{
                                                                name: 'Name', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                                                check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                                                required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                                            }}
                                                        />

                                                    }

                                                    {(pregunta.cuesTipo == 'texto' || pregunta.cuesTipo == 'textolongitud') &&
                                                        <Textbox
                                                            tabIndex="1"
                                                            type={'text'}
                                                            value={pregunta.value}
                                                            name={pregunta.cuesPregunta}
                                                            id={indexPreguntas + "a" + indiceSeleccionado}
                                                            classNameInput={"form-control"}
                                                            placeholder={pregunta.cuesPregunta}
                                                            onChange={async (valor) => {

                                                                var valueInput = valor

                                                                if (pregunta.cuesPregunta == 'Placa') {
                                                                    valueInput = valueInput.replace(/[^a-zA-Z0-9]/g, '')
                                                                }

                                                                cambiarValor(valueInput, pregunta, indexPreguntas)
                                                                if (pregunta.cuesPregunta == 'Placa') {

                                                                    setPlacaDuplicada(false)
                                                                    setMensajeDuplicado('')
                                                                    if ((valueInput.length > 6)) {
                                                                        obtenerDatosVehiculo(valueInput)
                                                                    }
                                                                }

                                                                if (pregunta.cuesPregunta == 'Motor' || pregunta.cuesPregunta == 'Chasis') {
                                                                    setPlacaDuplicada(false)
                                                                    setMensajeDuplicado('')
                                                                }
                                                            }}



                                                            esDependiente={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? false : true}
                                                            codPadre={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : pregunta.cuesPadre}
                                                            valorDependiente={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : pregunta.cuesDepende}
                                                            validate={categoriaSeleccionada.validate}
                                                            validationCallback={res => {

                                                                validationCallback2(res, pregunta.cuesPregunta)

                                                            }}
                                                            onBlur={(e) => {

                                                            }}
                                                            validationOption={{
                                                                type: 'string',
                                                                //required: true,
                                                                maxlength: parseInt(pregunta.cuesMaximo),
                                                                minLength: parseInt(pregunta.cuesMinimo),
                                                                //length: length,
                                                                //reg: reg ? new RegExp(reg) : null,
                                                                //min: min,
                                                                //max: max,
                                                                //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                                                                reg: (pregunta.cuesMaximo && pregunta.cuesMinimo) ? new RegExp(`^.{${pregunta.cuesMinimo},${pregunta.cuesMaximo}}$`) : null, //Optional.[Bool].Default: "" Custom regex.
                                                                msgOnError: (pregunta.cuesMaximo && pregunta.cuesMinimo) ?
                                                                    `El campo debe ser de mínimo ${pregunta.cuesMinimo} y máximo ${pregunta.cuesMaximo} caracteres`
                                                                    : 'ingrese un valor '
                                                            }}

                                                        />
                                                    }



                                                    {pregunta.cuesTipo == 'fecha' &&
                                                        <DatePicker

                                                            dateFormat="dd/MM/yyyy"
                                                            isClearable={false}
                                                            selected={new Date(pregunta.value)}
                                                            onChange={(valor) => {
                                                                let dateParts = moment(new Date(valor)).format("DD/MM/YYYY").split("/");
                                                                let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                                                                cambiarValor(dateObject, pregunta, indexPreguntas)


                                                            }}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            className="form-control"

                                                        />

                                                    }

                                                    {(pregunta.cuesTipo == 'web' || pregunta.cuesTipo == 'select') &&



                                                        <div>

                                                            <SelectPreguntas
                                                                id={indexPreguntas + pregunta.cuesPregunta}
                                                                type={null}
                                                                buscarElemento={buscarElemento}
                                                                validate={categoriaSeleccionada.validate}
                                                                value={pregunta.value ? pregunta.value : pregunta.cuesPorcentajeValorAsegurado ? '' : null}
                                                                valueSelect={pregunta.valueSelect}
                                                                name={pregunta.cuesPregunta}
                                                                maxLength={null}
                                                                isMulti={pregunta.cuesMultiple == 'SI'}
                                                                values={pregunta.cuesOpcionesTipoSelect ? pregunta.cuesOpcionesTipoSelect.map(cues => { return { ...cues, label: cues.opcion, value: cues.opcion } }) : null}
                                                                minLength={null}
                                                                length={null}
                                                                setLoading={() => { }}
                                                                reg={null}
                                                                mensajeError={'Seleccione una opción'}
                                                                required={esPreguntaRequerida(pregunta, categoriaSeleccionada)}
                                                                placeholder={pregunta.cuesPregunta}
                                                                isSearchable={true}
                                                                peticiones={
                                                                    {
                                                                        "url": pregunta.cuesConsumoweb,
                                                                        "inputId": "actividadEmpresa",
                                                                        "value": pregunta.cuesValorweb,
                                                                        "label": pregunta.cuesCodigoweb,
                                                                        "metodo": 'GET',
                                                                        "body": {
                                                                            "empresa": "AIGMETROPOLITANA",
                                                                            "codProvincia": "$provincia",
                                                                            "ramo": "travel"
                                                                        },
                                                                        "atributo": pregunta.cuesParametroweb,
                                                                        "parametro": "empresa"

                                                                    }
                                                                }
                                                                esDependiente={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? false : true}
                                                                codPadre={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : pregunta.cuesPadre}
                                                                valorDependiente={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : pregunta.cuesDepende}
                                                                valorPadre={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : categoriaSeleccionada.preguntas.find(v => v.cuesPregunta == pregunta.cuesPadre) ? categoriaSeleccionada.preguntas.find(v => v.cuesPregunta == pregunta.cuesPadre).value : null}
                                                                hasError={!pregunta.value || pregunta.value == "" || (pregunta.value && pregunta.value.esBloqueante == 'SI')}
                                                                esBloqueante={(pregunta.value && pregunta.value.esBloqueante == 'SI')}
                                                                errorBloqueante={(pregunta.value && pregunta.value.esBloqueante == 'SI') ? pregunta.value.mensajeNoCotizar : null}
                                                                onChange={(valor) => {
                                                                    cambiarValor(valor, pregunta, indexPreguntas)


                                                                }}
                                                                validationCallback={(valor) => {


                                                                    validationCallback2(valor, pregunta.cuesPregunta)
                                                                }}
                                                            />

                                                        </div>

                                                    }

                                                    {pregunta.cuesTipo == 'numerico' &&

                                                        <Textbox
                                                            tabIndex="1"
                                                            type="number"
                                                            value={pregunta.value ? pregunta.value : pregunta.cuesPorcentajeValorAsegurado ? '' : ''}
                                                            name={pregunta.cuesPregunta}
                                                            id={pregunta.cuesPregunta + "23" + indiceSeleccionado + Math.random()}
                                                            placeholder={pregunta.cuesPregunta}
                                                            disabled={
                                                                isDisabled(pregunta, categoriaSeleccionada)
                                                            }
                                                            classNameInput={"form-control"}
                                                            onChange={(valor) => {

                                                                cambiarValor(valor, pregunta, indexPreguntas)

                                                            }}
                                                            validate={categoriaSeleccionada.validate}
                                                            validationCallback={(res) => {

                                                                validationCallback2(res, pregunta.cuesPregunta)
                                                            }

                                                            }

                                                            onBlur={(e) => {

                                                            }}
                                                            validationOption={{
                                                                name: pregunta.cuesOrden, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                required: !isDisabled(pregunta, categoriaSeleccionada),
                                                                type: 'number',
                                                                min: 1,
                                                                max: pregunta.cuesPorcentajeValorAsegurado ?
                                                                    (valorAsegurado * parseFloat(pregunta.cuesPorcentajeValorAsegurado)) / 100 :
                                                                    null,

                                                                msgOnError:
                                                                    pregunta.cuesPorcentajeValorAsegurado ?
                                                                        'El valor es requerido y no puede ser mayor a $' + (valorAsegurado * parseFloat(pregunta.cuesPorcentajeValorAsegurado)) / 100 :
                                                                        "Por favor ingrese solo valores numéricos",

                                                            }}
                                                        />


                                                    }
                                                    {pregunta.cuesTipo == 'numericoMaximoMinimo' &&

                                                        <Textbox
                                                            tabIndex="1"
                                                            type="number"
                                                            value={pregunta.value ? pregunta.value : pregunta.cuesPorcentajeValorAsegurado ? '' : ''}
                                                            name={pregunta.cuesPregunta}
                                                            id={pregunta.cuesPregunta + "23" + indiceSeleccionado + Math.random()}
                                                            placeholder={pregunta.cuesPregunta}
                                                            disabled={
                                                                isDisabled(pregunta, categoriaSeleccionada)
                                                            }
                                                            classNameInput={"form-control"}
                                                            onChange={(valor) => {

                                                                cambiarValor(valor, pregunta, indexPreguntas)

                                                            }}
                                                            validate={categoriaSeleccionada.validate}
                                                            validationCallback={(res) => {

                                                                validationCallback2(res, pregunta.cuesPregunta)
                                                            }

                                                            }

                                                            onBlur={(e) => {

                                                            }}
                                                            validationOption={{
                                                                name: pregunta.cuesOrden, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                required: !isDisabled(pregunta, categoriaSeleccionada),
                                                                type: 'number',
                                                                min: parseFloat(pregunta.cuesValorMinimo),
                                                                max: parseFloat(pregunta.cuesValorMaximo),
                                                                msgOnError: (parseFloat(pregunta.value) < parseFloat(pregunta.cuesValorMinimo)) ? pregunta.cuesTextoValorMinimo : (parseFloat(pregunta.value) > parseFloat(pregunta.cuesValorMaximo)) ? pregunta.cuesTextoValorMaximo : 'Ingrese un valor',

                                                            }}
                                                        />


                                                    }

                                                    {pregunta.cuesTipo == 'archivo' &&



                                                        <ComponentButtonS3
                                                            value={pregunta.value}
                                                            onChange={(valor) => {
                                                                cambiarValor(valor, pregunta, indexPreguntas)
                                                            }}
                                                            tipo={pregunta.cuesTipoArchivo == 'imagen' ? 'image/*' : ''}
                                                            validate={categoriaSeleccionada.validate}
                                                            validationCallback={(valor) => {

                                                                validationCallback2(valor, pregunta.cuesPregunta)
                                                            }}
                                                            mensajeError={'Seleccione un archivo'}
                                                            hasError={pregunta.value == "" || pregunta.value == null}
                                                        >

                                                        </ComponentButtonS3>


                                                    }

                                                    {pregunta.cuesTipo == 'lista' &&
                                                        <ComponentLista
                                                            pregunta={pregunta}
                                                            value={pregunta.value}
                                                            onChange={(valor) => {
                                                                cambiarValor(valor, pregunta, indexPreguntas)
                                                            }}
                                                        >
                                                        </ComponentLista>
                                                    }

                                                    {pregunta.cuesTipo == 'listaInputValoresEstablecidos' &&
                                                        <ComponentListaInputValoresEstablecidos
                                                            pregunta={pregunta}
                                                            value={pregunta.value ? pregunta.value : {}}
                                                            onChange={(valor) => {
                                                                cambiarValor(valor, pregunta, indexPreguntas)
                                                            }}
                                                        >
                                                        </ComponentListaInputValoresEstablecidos>
                                                    }




                                                </Col>
                                                <Col md={1}></Col>
                                            </Row>

                                        </div>
                                    )
                                })}

                            </div>
                        }

                    </CardBody>

                </Card>
            </Col>
            <Col
                ref={mensajeValidacion}
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="div-align-center"
            >
                <div>
                    {placaDuplicada &&

                        <React.Fragment>
                            <Alert color="danger">
                                <center><p>{mensajeDuplicado}</p></center>
                            </Alert>

                        </React.Fragment>
                    }

                    <br></br>

                </div>
            </Col>
            <Col
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="div-align-center"
            >
                <Row>
                    <Col style={{ textAlign: 'right' }}>

                        <Button
                            className="btn btn-detail-gray"
                            style={{ margin: "auto" }}

                            onClick={() => {

                                if (indiceSeleccionado != 0) {
                                    obtenerSiguienteElemento('anterior')
                                } else {
                                    onRegresar()
                                }


                            }}
                        >
                            <i className="fa fa-chevron-circle-left" aria-hidden="true" />
                            {" "}{indiceSeleccionado != 0 ? 'ANTERIOR' : 'REGRESAR'}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            className="btn btn-primary"
                            disabled={placaDuplicada}

                            style={{ display: "block", marginRight: "5px" }}
                            onClick={async () => {


                                if (indiceSeleccionado != categorias.length - 1) {


                                    if (!tieneErrores()) {
                                        obtenerSiguienteElemento('siguiente')
                                    }


                                } else {



                                    if (!tieneErrores()) {

                                        if (aplicaControlDuplicidad) {
                                            const placa = categoriaSeleccionada.preguntas.find(pregunta => pregunta.cuesPregunta == 'Placa').value
                                            const motor = categoriaSeleccionada.preguntas.find(pregunta => pregunta.cuesPregunta == 'Motor').value
                                            const chasis = categoriaSeleccionada.preguntas.find(pregunta => pregunta.cuesPregunta == 'Chasis').value
                                            const duplicado = await validarDuplicidad(placa, motor, chasis)
                                            if (duplicado.tienePolizaVigente == true) {
                                                setPlacaDuplicada(true)
                                                setMensajeDuplicado(duplicado.mensajePoliza)




                                            } else {
                                                setPlacaDuplicada(false)
                                                setMensajeDuplicado('')
                                                guardarInformacion(categorias)

                                            }
                                        } else {
                                            guardarInformacion(categorias)
                                        }

                                    }

                                }

                            }}
                        >

                            {indiceSeleccionado == categorias.length - 1 ? 'CONTINUAR' : "SIGUIENTE"}
                            {" "}
                            <i
                                className="fa fa-chevron-circle-right"
                                aria-hidden="true"
                            />

                        </Button>
                    </Col>
                </Row>


            </Col>
        </Row>



    )

}

export default ComponentPreguntasParametrico